import React, { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa6';

const PHONE = '923105245223';

const MESSAGES = [
  { label: 'Contact us', text: 'Hello Sir, I want to connect' },
  { label: 'Suggest a topic', text: 'Hello Sir, I want to suggest a topic' },
  { label: 'Report an error', text: 'Hello Sir, I want to report an error' },
];

const CYCLE_MS = 3500;

const WhatsAppButton = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % MESSAGES.length), CYCLE_MS);
    return () => clearInterval(id);
  }, []);

  const { label, text } = MESSAGES[i];
  const href = `https://api.whatsapp.com/send?phone=${PHONE}&text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="wa-fab fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-green-600/40 focus:outline-none focus:ring-2 focus:ring-green-400"
    >
      <span key={i} className="wa-fab-label">{label}</span>
      <FaWhatsapp className="wa-fab-icon w-7 h-7" />
    </a>
  );
};

export default WhatsAppButton;
